/** Extrai YYYY-MM-DD de ISO/timestamptz sem aplicar fuso horário local. */
export function parseDateOnlyYmd(value: string | null | undefined): string | null {
  if (!value) return null
  const m = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/)
  return m ? `${m[1]}-${m[2]}-${m[3]}` : null
}

/** Formata data de calendário (occurred_at, vigência, etc.) em dd/mm/aaaa. */
export function formatDateOnlyPtBr(value: string | null | undefined): string {
  const ymd = parseDateOnlyYmd(value)
  if (!ymd) return '—'
  const [y, m, d] = ymd.split('-')
  return `${d}/${m}/${y}`
}

/** Data local de hoje (input type="date"). */
export function localTodayYmd(): string {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/** Grava data de ocorrência em timestamptz sem “voltar um dia” na listagem (meio-dia UTC). */
export function dateOnlyToTimestamptz(ymd: string): string {
  return `${ymd}T12:00:00.000Z`
}

/** Limite inferior (inclusive) para filtro por data de calendário em colunas timestamptz. */
export function dateOnlyFilterGte(ymd: string): string {
  return `${ymd}T00:00:00.000Z`
}

/** Limite superior (inclusive) para filtro por data de calendário em colunas timestamptz. */
export function dateOnlyFilterLte(ymd: string): string {
  return `${ymd}T23:59:59.999Z`
}

const SAO_PAULO_TZ = 'America/Sao_Paulo'

/** YYYY-MM-DD no fuso America/Sao_Paulo. */
export function ymdInSaoPaulo(date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: SAO_PAULO_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date)
}

/**
 * Início do dia para colunas `timestamp` (sem timezone), gravadas em horário de Brasília.
 * Não usar offset UTC — a coluna não é timestamptz.
 */
export function timestampDayStart(ymd: string): string {
  return `${ymd}T00:00:00`
}

/** Fim do dia para colunas `timestamp` sem timezone (horário de Brasília). */
export function timestampDayEnd(ymd: string): string {
  return `${ymd}T23:59:59`
}
